import { FC, useContext } from "react";

import { FormType, PaymentMethod } from "@simplyk/common";

import { FrontendFormContext } from "../../../../../../common/contexts/FrontendFormContext";

import { useSubmitNewBids } from "./useSubmitNewBids";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useCardPaymentFormValid } from "@/canvas/features/FormV2/steps/step2/hooks/useCardPaymentFormValid";
import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { usePreviewContext } from "@/features/LiveFormEditor/LivePreview/contexts/PreviewContext";
import { HeartsFormButton } from "@/forms-design-system/HeartsFormButton/HeartsFormButton";
import { Lock } from "@/icons/outlined";

export const SubmitNewBidsButton: FC = () => {
  const { t } = useTranslate();
  const { formObject: ticketingForm, form } = useFormV2Context(FormType.Ticketing);
  const { selectedPaymentMethod, isExpressCheckoutLoading, showProceedButton } = useContext(FrontendFormContext);

  const { submitNewBidsWithInput, paymentInProgress } = useSubmitNewBids();

  const { isPreview } = usePreviewContext();
  const { handleSubmit, formState } = form;
  const { isCardPaymentFormValid } = useCardPaymentFormValid();

  const shouldTriggerHeartsAnimation = Boolean(
    formState.isValid && (selectedPaymentMethod === PaymentMethod.Card ? isCardPaymentFormValid : true)
  );

  const handleFormSubmit = handleSubmit(async (paymentInput) => {
    await submitNewBidsWithInput(paymentInput);
  });

  const isPaymentDisabled = ticketingForm?.organization?.isPaymentDisabled || false;

  return (
    <HeartsFormButton
      onClick={handleFormSubmit}
      disabled={isPreview || isExpressCheckoutLoading || paymentInProgress || isPaymentDisabled}
      isLoading={paymentInProgress}
      animated={shouldTriggerHeartsAnimation}
      loop={true}
      endIcon={showProceedButton ? <Lock /> : undefined}
      data-test="form-v2-submit-button"
    >
      {t("common", "paymentMethod.button.placeBid", {
        count: form.getValues("ticketsPurchased")?.filter((item) => (item?.bid ?? 0) > 0).length ?? 0,
      })}
    </HeartsFormButton>
  );
};
